import { AwsRum, AwsRumConfig } from 'aws-rum-web';

export type RumClientConfig = {
  appMonitorId: string;
  identityPoolId: string;
  guestRoleArn: string;
  sessionSampleRate: number;
  region: string;
};


export const RumClient = {
  initialise: ({
    appMonitorId,
    identityPoolId,
    guestRoleArn,
    sessionSampleRate = 1,
    region = 'ap-southeast-2',
  }: RumClientConfig): AwsRum => {
    const rumConfig: AwsRumConfig = {
      allowCookies: true,
      endpoint: 'https://dataplane.rum.ap-southeast-2.amazonaws.com',
      guestRoleArn: guestRoleArn,
      identityPoolId: identityPoolId,
      sessionSampleRate,
      telemetries: [
        'performance',
        'errors',
        ['http', { addXRayTraceIdHeader: false }]
      ],
      enableXRay: true
    };

    return new AwsRum(appMonitorId, '1.0.0', region, rumConfig);
  }
};
